import type { Rule, RuleObject } from 'antd/es/form';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { ExtendedChannelFormContentValues } from '../ChannelsSection';

export const useTagsRules = (): Rule[] => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      ({ getFieldValue }) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- antd interface
        const organization: ExtendedChannelFormContentValues['organization'] | undefined =
          getFieldValue('organization');

        return {
          message: t('Error: Selected tags are not valid for current organization'),
          // eslint-disable-next-line @typescript-eslint/require-await -- antd interface
          async validator(_: RuleObject, values?: string[]) {
            const organizationTagsIds = new Set(organization?.originalOrganization.channelTags?.map((tag) => tag.name));

            if (values && !values.every((tag) => organizationTagsIds.has(tag))) {
              throw new Error('Error: Selected tags are not valid for current organization');
            }
          },
        };
      },
      { required: true },
    ],
    [t],
  );
};
